var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79427 5.96995C7.79427 5.71536 7.61011 5.50953 7.36094 5.43912C6.67302 5.24953 6.16927 4.6212 6.16927 3.8737V1.16536H6.71094C7.00885 1.16536 7.2526 0.921615 7.2526 0.623698C7.2526 0.325781 7.00885 0.0820312 6.71094 0.0820312H1.29427C0.996354 0.0820312 0.752604 0.325781 0.752604 0.623698C0.752604 0.921615 0.996354 1.16536 1.29427 1.16536H1.83594V3.8737C1.83594 4.6212 1.33219 5.24953 0.644271 5.43912C0.395104 5.50953 0.210938 5.71536 0.210938 5.96995V6.04036C0.210938 6.33828 0.454688 6.58203 0.752604 6.58203H3.4501L3.46094 10.3737C3.46094 10.6716 3.70469 10.9154 4.0026 10.9154C4.30052 10.9154 4.54427 10.6716 4.54427 10.3737L4.53344 6.58203H7.2526C7.55052 6.58203 7.79427 6.33828 7.79427 6.04036V5.96995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.60623d7671b3e2428618241314e54dae.svg";
export { ForwardRef as ReactComponent };